import "./PrivacyPolicy.css";

export default function PrivacyPolicy() {
  return (
    <div className="privacy-policy-main">
      <div className="privacy-policy-contents">
        <h1>Privacy Policy</h1>
        <p>
          We respect your privacy and are committed to protecting your personal
          information. This Privacy Policy outlines how we collect, use, and
          protect information when you visit and interact with our website.
        </p>

        <h2>User Data Policy</h2>
        <p>
          This website does not directly collect personally identifiable
          information such as your name, email address, or phone number. You can
          access and use all our games without providing any personal data.
        </p>

        <h2>Cookies & Tracking Technologies</h2>
        <p>
          We may use third-party services like Google AdSense, which use cookies
          and similar technologies to serve relevant advertisements to you and
          track ad performance. These services may automatically collect
          non-personally identifiable information such as your IP address,
          browser type, device type, and time of visit.
        </p>
        <p>
          Cookies are small text files stored on your device. You can control or
          disable cookies in your browser settings. However, disabling cookies
          may impact ad relevance and user experience.
        </p>

        <h2>Third-Party Services</h2>
        <p>
          Our website uses services like Google AdSense to display ads. These
          third parties may use cookies, web beacons, and similar technologies
          to collect data about your interactions with ads and content. You can
          learn more about how Google uses your data&nbsp;
          <a
            href="https://policies.google.com/technologies/ads"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>
          .
        </p>

        <h2>Data Sharing</h2>
        <p>
          We do not share, sell, or rent your information to any third parties
          outside of the services required to operate and monetize this website.
        </p>

        <h2>Content Ownership</h2>
        <p>
          All games featured on this website are original and created
          specifically for this platform. They are not copied or republished
          from other sources. Any similarities to existing games are purely
          coincidental.
        </p>

        <h2>Policy Updates</h2>
        <p>
          This Privacy Policy may be updated occasionally to reflect changes in
          services or applicable laws. Any changes will be posted on this page
          with a revised date.
        </p>

        <h2>Contact</h2>
        <p>
          For any questions or privacy-related concerns, please contact us at:
          <br />
          <strong>joshi.yashshashikant@gmail.com</strong>
        </p>

        <p>
          This site may be maintained with help from independent technical
          contributors.
        </p>
        <br />
        <p>Last updated: May 2025</p>
      </div>
    </div>
  );
}
